import { createFileRoute } from '@tanstack/react-router'
import OnboardingLayout from '@/pages/auth/onboarding/onboarding-layout'
import { TeamInvitation } from '@/pages/auth/onboarding/components/team-invitation'
import { useOnboardingTracking } from '@/hooks/use-onboarding-tracking'

export const Route = createFileRoute('/(auth)/onboarding/team')({
  component: TeamPage,
})

function TeamPage() {
  const { track } = useOnboardingTracking()

  const sideContent = (
    <div>
      <h3 className="font-semibold">Team Power</h3>
      <p className="mt-1 text-sm text-muted-foreground">
        Teams that collaborate on documentation are 3x more likely to keep it up-to-date.
      </p>
    </div>
  )

  return (
    <OnboardingLayout currentStep={6} totalSteps={7} sideContent={sideContent}>
      <TeamInvitation onAnalytics={track} />
    </OnboardingLayout>
  )
}